import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faEnvelope, faLock } from '@fortawesome/free-solid-svg-icons';
import { SimpleModal } from 'Src/components/SimpleModal/SimpleModal';
import './GeneralMessagesUnavailableModal.scss';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onViewModule: () => void;
}

export const GeneralMessagesUnavailableModal: React.FC<Props> = ({ isOpen, onClose, onViewModule }) => (
  <SimpleModal
    isOpen={isOpen}
    onCloseClick={onClose}
    onCloseIconClick={onClose}
    customClass="gmUnavailableDialog"
    dialogStyle={{ maxWidth: 460 }}
    showHeader={false}
    showFooter={false}
    isBodyBold={false}
  >
    <div className="gmUnavailable">
      <span className="gmUnavailable__badge">Add-on module</span>
      <div className="gmUnavailable__hero">
        <span className="gmUnavailable__icon"><FontAwesomeIcon icon={faEnvelope} /></span>
        <span className="gmUnavailable__lock"><FontAwesomeIcon icon={faLock} /></span>
      </div>
      <h2>General Messages is not switched on</h2>
      <p>Use General Messages to reach selected students, parents and staff with targeted announcements from one place.</p>
      <ul>
        <li><FontAwesomeIcon icon={faCheck} /> Send to parents, students, or both at the same time</li>
        <li><FontAwesomeIcon icon={faCheck} /> Personalise messages and reuse existing templates</li>
        <li><FontAwesomeIcon icon={faCheck} /> Track delivery and read status after sending</li>
      </ul>
      <div className="gmUnavailable__note">
        No rush. It is not available for this school right now, but it can be enabled from Modules &amp; plans when you are ready.
      </div>
      <div className="gmUnavailable__foot">
        <button type="button" className="people-btn people-btn--secondary" onClick={onClose}>Not now</button>
        <button type="button" className="people-btn people-btn--primary" onClick={onViewModule}>Go to Modules &amp; plans</button>
      </div>
    </div>
  </SimpleModal>
);
